
import Button from '../../../components/base/Button';
import { useTranslation } from 'react-i18next';

export default function ServicesPreviewSection() {
  const { t } = useTranslation();

  const services = [
    {
      id: 'influencer',
      titleKey: 'service_influencer',
      titleEnKey: 'service_influencer_en',
      descKey: 'service_influencer_desc',
      features: [
        'service_influencer_feature1',
        'service_influencer_feature2', 
        'service_influencer_feature3',
        'service_influencer_feature4'
      ],
      icon: 'ri-user-star-line',
      gradient: 'from-pink-500 to-rose-500',
      image: '/resources/influencer-collab-001.jpg'
    },
    {
      id: 'amplification',
      titleKey: 'service_amplification',
      titleEnKey: 'service_amplification_en',
      descKey: 'service_amplification_desc',
      features: [
        'service_amplification_feature1',
        'service_amplification_feature2',
        'service_amplification_feature3',
        'service_amplification_feature4'
      ],
      icon: 'ri-megaphone-line',
      gradient: 'from-blue-500 to-cyan-500',
      image: '/resources/ad-amplification-001.jpg'
    },
    {
      id: 'integrated',
      titleKey: 'service_integrated',
      titleEnKey: 'service_integrated_en',
      descKey: 'service_integrated_desc',
      features: [
        'service_integrated_feature1',
        'service_integrated_feature2',
        'service_integrated_feature3',
        'service_integrated_feature4'
      ],
      icon: 'ri-settings-3-line',
      gradient: 'from-purple-500 to-indigo-500',
      image: '/resources/integrated-plan-001.jpg'
    }
  ];

  const handleScrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('services_title')}
          </h2>
          <p className="text-lg text-gray-600 mb-2">{t('services_subtitle')}</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services_description')}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div key={service.id} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group border border-gray-100">
              <div className="relative overflow-hidden">
                <img 
                  src={service.image}
                  alt={t(service.titleKey)}
                  className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className={`absolute top-4 left-4 w-12 h-12 bg-gradient-to-r ${service.gradient} rounded-lg flex items-center justify-center`}>
                  <i className={`${service.icon} text-white text-xl`}></i>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {t(service.titleKey)}
                </h3>
                <p className="text-sm text-blue-600 mb-4 font-medium">
                  {t(service.titleEnKey)}
                </p>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {t(service.descKey)}
                </p>
                
                <ul className="space-y-2 mb-6">
                  {service.features.map((featureKey, index) => (
                    <li key={index} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {t(featureKey)}
                    </li>
                  ))}
                </ul>
                
                <button
                  onClick={handleScrollToContact}
                  className="cursor-pointer w-full"
                >
                  <Button 
                    variant="outline" 
                    className="w-full hover:bg-blue-50 hover:border-blue-300"
                  >
                    {t('btn_learn_details')}
                  </Button>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={handleScrollToContact}
            className="cursor-pointer"
          >
            <Button size="lg" className="px-8">
              <i className="ri-arrow-right-line mr-2"></i>
              {t('btn_view_full_services')}
            </Button>
          </button>
        </div>
      </div>
    </section>
  );
}
